import { Link } from "react-router-dom";
import { brand, navLinks } from "@/mocks/site";

const columns = [
  {
    title: "快速导航",
    links: [
      { label: "首页", to: "/" },
      { label: "选题库", to: "/topics" },
      { label: "投稿指南", to: "/guide" },
    ],
  },
  {
    title: "参与方式",
    links: [
      { label: "我要投稿", to: "/submit" },
      { label: "关于我们", to: "/about" },
      { label: "常见问题", to: "/#faq" },
    ],
  },
];

export default function SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="mt-auto w-full bg-secondary-900 text-background-100">
      <div className="mx-auto w-full px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-bold text-background-50">
                爆
              </span>
              <span className="font-heading text-lg font-bold text-background-50">{brand.name}</span>
            </div>
            <p className="mt-5 max-w-md text-sm leading-relaxed text-background-200/80">
              {brand.intro}
            </p>
            <p className="mt-5 flex items-center gap-2 text-sm text-background-200/80">
              <i className="ri-mail-line text-base leading-none text-accent-400"></i>
              投稿与合作：{brand.email}
            </p>
          </div>

          <div className="md:col-span-7">
            <div className="grid grid-cols-1 gap-8 sm:grid-cols-3">
              {columns.map((col) => (
                <div key={col.title}>
                  <h3 className="font-heading text-sm font-semibold text-background-50">{col.title}</h3>
                  <ul className="mt-4 space-y-3">
                    {col.links.map((link) => (
                      <li key={link.label}>
                        <Link
                          to={link.to}
                          className="text-sm text-background-200/80 transition-colors hover:text-accent-400 cursor-pointer"
                        >
                          {link.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
              <div>
                <h3 className="font-heading text-sm font-semibold text-background-50">投稿提示</h3>
                <p className="mt-4 text-sm leading-relaxed text-background-200/80">
                  {brand.replyPolicy}，请保留原始材料，勿在公开平台先行发布。
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-100/15 pt-6 text-xs text-background-200/60 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} {brand.name} · 内容仅作选题参考，投稿请以真实材料为准</p>
          <p className="flex items-center gap-4">
            <Link to="/about" className="transition-colors hover:text-accent-400 cursor-pointer">关于我们</Link>
            <Link to="/submit" className="transition-colors hover:text-accent-400 cursor-pointer">我要投稿</Link>
          </p>
        </div>
      </div>
    </footer>
  );
}